import request from 'superagent';


export const REQUEST_CONNECTION = 'REQUEST_CONNECTION';
export const RECEIVE_CONNECTION = 'RECEIVE_CONNECTION';
export const REQUEST_DISCONNECTION = 'REQUEST_DISCONNECTION';
export const RECEIVE_DISCONNECTION = 'RECEIVE_DISCONNECTION';
export const REQUEST_CONNECTIONS = 'REQUEST_CONNECTIONS';
export const RECEIVE_CONNECTIONS = 'RECEIVE_CONNECTIONS';
export const SERVICE_ERROR = 'SERVICE_ERROR';


export const connectKloudless = (svcName, connectionDetails) => (dispatch) => {
  dispatch({ type: REQUEST_CONNECTION });

  function onSuccess(response) {
    if (response.status !== 201) {
      return onFailure(response.message || 'service error');
    }

    const { service, connection_id } = response.body.integration;

    dispatch({
      type: RECEIVE_CONNECTION,
      results: [{ service, connectionId: connection_id }],
    });
  }

  function onFailure(errorMessage) {
    dispatch({
      type: RECEIVE_CONNECTION,
      results: errorMessage,
    });
  }

  return request
    .post('/rpc/integrations/connections')
    .send({
      integration_type: 'files',
      service: svcName,
      connection_details: connectionDetails,
    })
    .then(onSuccess, onFailure);
};

export const disconnectKloudless = connectionId => (dispatch) => {
  dispatch({ type: REQUEST_DISCONNECTION });

  function onSuccess() {
    dispatch({
      type: RECEIVE_DISCONNECTION,
      connectionId,
    });
  }

  function onFailure(errorMessage) {
    dispatch({
      type: RECEIVE_DISCONNECTION,
      errorMessage,
    });
  }

  return request
    .delete(`/rpc/integrations/connections/${connectionId}`)
    .then(onSuccess, onFailure);
};

export const connections = () => (dispatch) => {
  dispatch({ type: REQUEST_CONNECTIONS });

  function onSuccess(response) {
    if (response.status !== 200) {
      return onFailure(response.message || 'service error');
    }

    const { integrations = [] } = response.body;
    const results = integrations.map(p => ({
      service: p.service,
      connectionId: p.connection_id,
    }));

    dispatch({
      type: RECEIVE_CONNECTIONS,
      results,
    });
  }

  function onFailure(errorMessage) {
    dispatch({
      type: RECEIVE_CONNECTIONS,
      errorMessage,
    });
  }

  return request
    .get('/rpc/integrations/connections')
    .then(onSuccess, onFailure);
};



/** WEBPACK FOOTER **
 ** ./src/redux/actions/kloudlessActions.js
 **/